import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  type?: string;
  jsonLd?: object[];
}

export default function SeoMeta({ title, description, type = "website", jsonLd }: SeoProps) {
  useEffect(() => {
    document.title = title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", description);
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", title);
    document
      .querySelector('meta[property="og:description"]')
      ?.setAttribute("content", description);
    document.querySelector('meta[property="og:type"]')?.setAttribute("content", type);

    const existing = document.getElementById("page-jsonld");
    if (existing) existing.remove();
    if (jsonLd && jsonLd.length) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.textContent = JSON.stringify(jsonLd.length === 1 ? jsonLd[0] : jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, type, jsonLd]);

  return null;
}